"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _actions = require("./actions");

var _constants = require("./constants");

var _API = _interopRequireDefault(require("./API"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var fetchIrisEntity = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getFields.bind(null, [_constants.MARKETING_PRODUCT_LEVEL, _constants.MARKETING_TRIAL_PRODUCT_LEVEL, _constants.SALES_PRODUCT_LEVEL], [_constants.PAID_SEATS]),
  initiatingActionType: _actions.IRISActionTypes.FETCH_IRIS,
  requestActions: _actions.FetchIris,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED],
  requestStatusSelector: (0, _getRequestStatus.default)(_actions.IRISActionTypes.FETCH_IRIS)
}));
var _default = fetchIrisEntity;
exports.default = _default;
module.exports = exports.default;